/**
 * 
 * Author: Yu
 * Create Time: 2019年9月16日12:56:24
 * Description: 货币输入框组件注册
 * 
 */
import currencyInputComponent from "./currencyInput.vue";

const currencyInput = {
    install:function(Vue){
        Vue.component("currencyInput",currencyInputComponent)
    }
}

export default currencyInput


// WEBPACK FOOTER //
// ./src/components/input/currencyInput.js